<template lang="html">
    <div class="has-text-centered">
        <iframe v-if="config.src"
            :src="config.src" 
            :height="height"
            :width="width"
        ></iframe>
        <iframe v-if="config.srcdoc"
            :srcdoc="config.srcdoc" 
            :height="height"
            :width="width"
        ></iframe>
    </div>  
</template>
  
<script>
export default {
    name: 'bulmaIframe',
    components: {},
    props: {
        id: String,
    },
    data: function () {
      return {}
    },
    watch: {},
    computed: {
        config: function () {
            return this.$store.getters.getObject(this.id).data;
        },
        height() {
            return this.config.height || 150
        },
        width() {
            return this.config.width || "100%"
        }
    },
    mounted: function() {},
    filters: {},
    methods: {}
}
</script>